module.exports = "<div class=\"flex-container pad-x-xs\">\n\n  <td-search-box class=\"pad-right-md\" [placeholder]=\"searchPlaceHolder\"\n    [showUnderline]=\"true\"\n    [alwaysVisible]=\"true\"\n    [debounce]=\"300\"\n    (searchDebounce)=\"onSearch($event)\" flex>\n  </td-search-box>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/search-input/search-input.component.html
// module id = ./src/app/shared-components/search-input/search-input.component.html
// module chunks = main